/**
 * Mixin for sorting components
 * Sample of columnsConfig:
 * columnsConfig: [
        {
          label: 'All Attributes',
          propName: 'label'
        },
        {
          label: 'Date',
          propName: 'target_date',
          sortPreFormatting: (timestamp) => {
              if (!timestamp) {
                return null
              }
            return moment(timestamp).valueOf()
          }
        }
      ]
 */

import helper from '@/services/Helper'

export default {

  data () {
    return {
      isShiftPressed: false,
      sortConfig: [{
        sortDirection: helper.DIRECTION_ASC,
        propertyName: 'label'
      }]
    }
  },
  methods: {
    /**
     * isShiftPressed notifies whether Shift button was pressed or not
     * is used when we wont to handle Shift press with non-multisorting logic
     * @param cell from table config
     * @param isShiftPressed
     */
    onHeaderCellClicked (cell, isShiftPressed = false) {
      this.isShiftPressed = isShiftPressed
      const existingCell = this.sortConfig
        .find(existingCell => existingCell.propertyName === cell.propName)
      if (!existingCell) {
        this.sortConfig = [
          this.getNewSortConfigItem(cell)
        ]
      } else {
        const newDirection = this.getSortDirectionByCurrent(existingCell.sortDirection)
        if (newDirection) {
          existingCell.sortDirection = newDirection
          this.sortConfig = [existingCell]
        } else {
          this.sortConfig = []
        }
      }
    },
    /**
     * separate method for tables with multisorting triggered by press Shift
     * unlike method above this is assigned as separate listener in template on @click.shift
     * general click method onHeaderCellClicked should be assigned to @click.exact
     * @param cell
     */
    onHeaderCellClickedWithShift (cell) {
      const existingCellIndex = this.sortConfig
        .findIndex(existingCell => existingCell.propertyName === cell.property)
      if (existingCellIndex === -1) {
        this.sortConfig = [
          ...this.sortConfig,
          this.getNewSortConfigItem(cell)
        ]
      } else {
        const existingCell = this.sortConfig[ existingCellIndex ]
        const newDirection = this.getSortDirectionByCurrent(existingCell.sortDirection)
        if (newDirection) {
          existingCell.sortDirection = newDirection
          this.sortConfig[ existingCellIndex ] = existingCell
        } else {
          this.sortConfig.splice(existingCellIndex, 1)
        }
        this.sortConfig = [ ...this.sortConfig ]
      }
    },
    getNewSortConfigItem (cell) {
      return {
        sortDirection: this.getSortDirectionByCurrent(),
        propertyName: cell.propName,
        valuePreFormatter: this.getSortPreformatting(cell)
      }
    },
    getSortDirectionByCurrent (direction) {
      switch (direction) {
        case helper.DIRECTION_ASC:
          return helper.DIRECTION_DESC
        case helper.DIRECTION_DESC:
          return null
        default:
          return helper.DIRECTION_ASC
      }
    },
    /**
     * sortPreFormatting sample:
     * (timestamp) => {
              if (!timestamp) {
                return null
              }
            return moment(timestamp).valueOf()
          }
     * @param cell
     * @returns {*}
     */
    getSortPreformatting (cell) {
      return typeof cell.sortPreFormatting === 'function' ? cell.sortPreFormatting : null
    }
  }
}
